/**
 * Throttle function executions to frame rate.
 * 
 * @param func Original function.
 * @returns Throttled function.
 */
// tslint:disable-next-line:ban-types
function throttleToFrame<T extends Function>( func: T ): T
{
	let running: boolean = false;
	let args: any[];
	
	return function throttled( this: any, ...rest: any[] ): void
	{
		args = rest;
		
		if ( running )
		{
			return;
		}
		
		running = true;
		
		requestAnimationFrame(
			() =>
			{
				running = false;
				func.apply( this, args );
			},
		);
	} as any;
}

/**
 * Module.
 */
export {
	throttleToFrame as default,
};



// WEBPACK FOOTER //
// ./utils/events/throttleToFrame.ts